import React from 'react';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import RestaurantMenuPage from 'modules/restaurant/menu/RestaurantMenuPage';

export default function DashRestaurantMenu() {
    return (
        <DashContainer title='Cardápio'>
            <RestaurantMenuPage />
        </DashContainer>
    );
}
